export default "__VITE_ASSET__01a0daf1__"